import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useRouter } from "src/hooks/useRouter";
interface IConfirmPolicyProps {
  priceType: string;
  selectPayType: string;
  currency: string;
  handleChange: React.ChangeEventHandler<HTMLInputElement>;
}

// 이니시스 or 현금결제 선택
const SelectPayType = ({
  priceType,
  selectPayType,
  currency,
  handleChange,
}: IConfirmPolicyProps) => {
  const { t } = useTranslation();
  const { lang } = useRouter();
  return (
    <>
      {/* premium일때만 표기되는 듯 */}
      <h4 className="form-title">
        {priceType && t("siteType.basic.detail.payment.title")}
      </h4>

      <div className="d-flex gap-4">
        <Form.Check
          name="selectPayType"
          type="radio"
          id="selectPayType_card"
          value="card"
          checked={selectPayType === "card"}
          onChange={handleChange}
          label={
            <span className="form-input-label">
              {currency === "WON" ? (
                <i className="icon_inicis" />
              ) : (
                <i className="icon_paypal" />
              )}
            </span>
          }
        />

        {currency === "WON" && (
          <Form.Check
            type="radio"
            name="selectPayType"
            id="selectPayType_cash"
            value="cash"
            checked={selectPayType === "cash"}
            onChange={handleChange}
            label={
              <span
                className={`form-input-label ${lang === "ko" ? "" : "ml-24"}`}
              >
                {t("cashStatus.pay_cash")}
              </span>
            }
          />
        )}
      </div>
    </>
  );
};

export default SelectPayType;
